export default __webpack_public_path__ + "static/media/Comment.58d25881.svg";